import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { useEffect, useState } from 'react';

import CartStore from '../store/cart';
import LoaderStore from '../store/loader';
import { ActiveProduct } from '../store/products';

import styles from './LandingPageLayout.module.scss';
import OfferList from './ProductsMenu/OfferList';
import OfferTile from './ProductsMenu/OfferTile';
import ProductListItem from './ProductsMenu/ProductListItem';

export default function LandingPageLayout({
  showProductCategories = false,
  cmsData = {},
  products = [],
  categoriesShowing = [],
  offersShowing = [],
}) {
  const section = cmsData?.fields?.sections?.[0];
  const heading = section?.heading || '';
  const imgSrc = section?.image?.path;
  const imgTitle = cmsData?.title || '';
  const text = section?.text || '';
  const showBySelection = 'default';
  const [isCartVisible, setIsCartVisible] = useState(false);

  useEffect(() => {
    const isCartVisible$ = CartStore.getIsVisble$().subscribe(setIsCartVisible);
    if (ActiveProduct.getValue() !== '') {
      LoaderStore.addEvent('FEATURED_SCROLL');
      scrollToActiveProduct();
    }
    return () => {
      isCartVisible$.unsubscribe();
    };
  }, []);

  function scrollToActiveProduct() {
    setTimeout(() => {
      const elemToScrollTo = document.getElementById(`pr${ActiveProduct.getValue()}`);
      if (elemToScrollTo) {
        elemToScrollTo.scrollIntoView({
          behavior: 'auto',
          block: 'center',
        });
        ActiveProduct.update('');
        LoaderStore.removeEvent('FEATURED_SCROLL');
      } else {
        ActiveProduct.update('');
      }
    }, 500);
  }

  if (!products) return null;

  return (
    <section className={styles.content}>
      {imgSrc && (
        <div className={styles.imageContainer}>
          <img className={styles.img} src={imgSrc} alt={imgTitle} />
        </div>
      )}
      <div className={styles.listHeader}>
        <h1 className={styles.listTitle}>{heading}</h1>
      </div>

      <div className={styles.listText} dangerouslySetInnerHTML={{ __html: text }} />
      {!showProductCategories ? (
        <div
          className={cn(styles.productList, {
            [styles.spaceOpenCart]: isCartVisible,
          })}
        >
          {!isEmpty(offersShowing) && offersShowing.map(offer => <OfferTile key={offer.friendlyId} offer={offer} />)}
          {!isEmpty(products) && products.map(product => <ProductListItem key={product._id} _product={product} />)}
        </div>
      ) : (
        <div className={styles.defaultContainer}>
          <div className={styles.listSearch}>
            <OfferList offers={offersShowing} showBySelection={showBySelection} />
          </div>
          <ul className={cn(styles.listSearch)}>
            {categoriesShowing.map((c, index) => (
              <div key={c._id}>
                <div className={styles.listHeader}>
                  <h2 className={styles.listTitle}>{c.name}</h2>
                </div>
                <div className={styles.listContainer} data-cy="search-list">
                  {products[index] && products[index].map(p => <ProductListItem key={p._id} _product={p} />)}
                </div>
              </div>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
